import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import AssignmentIcon from "@mui/icons-material/Assignment";

import Button from "../../components/Button";
import TableComponent from "../../components/TableComponent";
import { getUsersInscribed } from "../../api/training.deprecated";

const UsersInscribedTraining = ({ match, history }) => {
  const { t } = useTranslation();
  const [usersInscribed, setUsersInscribed] = useState([]);
  const [refresh, setRefresh] = useState(1);

  useEffect(() => {
    (async () => {
      const trainingId = match.params.trainingId;
      const usersInscribed = await getUsersInscribed(trainingId);
      setUsersInscribed(usersInscribed);
    })();
  }, [refresh]);

  return (
    <>
      <Typography variant="h4">{t("training_pages.users_inscribed")}</Typography>
      {usersInscribed && (
        <TableComponent
          header={[
            { title: t("training_pages.user_id"), style: { width: "5%" } },
            { title: t("user") },
            { title: t("actions") },
          ]}
          renderChildren={(userInscribed, index) => (
            <TableRow key={index}>
              <TableCell>{userInscribed.user_id}</TableCell>
              <TableCell>{userInscribed.fullname}</TableCell>
              <TableCell>
                <Button
                  icon={<PublishedWithChangesIcon />}
                  onClick={() =>
                    history.push(
                      `/training-users/user/progress/${userInscribed.training_id}/${userInscribed.user_id}/${userInscribed.course_id}`,
                    )
                  }
                  title={t("training_pages.check_progress")}
                />
                <Button
                  icon={<AssignmentIcon />}
                  onClick={() =>
                    history.push(`/training-users/user/assessment/${userInscribed.id}/${userInscribed.operation_id}`)
                  }
                  title={t("training_pages.take_assessment")}
                />
              </TableCell>
            </TableRow>
          )}
          search={["user_id", "fullname", "company_name"]}
          pagination
          items={usersInscribed}
        />
      )}
      <Button title={t("back")} onClick={() => history.goBack()}>
        {t("back")}
      </Button>
    </>
  );
};

export default UsersInscribedTraining;
